import { Component } from '@angular/core';

@Component({
  selector: 'InvoiceUploader-cmp',
  templateUrl: './invoice-uploader.component.html',    
})
export class InvoiceUploaderComponent {}


// WEBPACK FOOTER //
// ./src/app/crm/kcc/invoice-uploader/invoice-uploader.component.ts